import {
  Component,
  NgZone,
  Renderer2,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import {
  AppUser,
  AuthService,
} from './core/modules/auth/services/auth.service';
import { UserLaneService } from './core/modules/user-lane/services/user-lane.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public title = 'Little SIS Premium';
  user: AppUser;

  readonly syncAgentSVGIcons = [
    'cog-transfer-outline',
    'ic_account_clock_outline',
    'ic_add_circle_outline_black',
    'ic_add_class_black',
    'ic_alarm_black',
    'ic_alarm_off_black',
    'ic_alarm_on_black',
    'ic_arrow_back_black',
    'ic_arrow_forward_black',
    'ic_build_black',
    'ic_class_edit_black',
    'ic_delete_black',
    'ic_edit_black',
    'ic_exclude_person_black',
    'ic_explore_black',
    'ic_favorite',
    'ic_file_upload_black',
    'ic_google_classroom',
    'ic_handyman',
    'ic_human_male_board',
    'ic_info_black',
    'ic_info_outline_black',
    'ic_play_arrow_black',
    'ic_play_circle_filled_black',
    'ic_play_circle_outline_black',
    'ic_potential_class_link',
    'ic_saved_class_exception',
    'ic_schedule',
    'ic_school_black',
    'ic_settings_backup_restore_black',
    'ic_sync_black',
  ];

  constructor(
    public authService: AuthService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private translate: TranslateService,
    private renderer: Renderer2,
    private userlaneService: UserLaneService,
    private router: Router,
    private matDialog: MatDialog,
    private ngZone: NgZone,
    private window: Window,
  ) {

    translate.setDefaultLang('en');
    
    this.userlaneService.renderer = this.renderer;
    this.userlaneService.init();

    this.authService.appUser$.subscribe((user) => {
      this.user = this.authService.appUser;
    });

    for (const icon in this.syncAgentSVGIcons) {
      this.matIconRegistry.addSvgIcon(
        this.syncAgentSVGIcons[icon],
        this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/${this.syncAgentSVGIcons[icon]}.svg`)
      );
    }

    this.matIconRegistry.addSvgIcon(
      'ls_sync_agent',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/images/logos/ls-sync-48.svg`)
    );

    if (this.window && (this.window as any).Cypress) {
      (this.window as any).cypressNavigateByUrl = (url: string) => this.cypressNavigateByUrl(url);
      (this.window as any).cypressCloseAllMatDialogs = () => this.cypressCloseAllMatDialogs();
    }

  }

  private cypressNavigateByUrl(url: string) {
    this.ngZone.run(() => {
      this.router.navigateByUrl(url);
    });
  }

  private cypressCloseAllMatDialogs() {
    this.matDialog.closeAll();
  }

}
